import type { ChangeEvent } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppTable } from "../../../shared/components/AppTable";
import { VersionsTableBody } from "./VersionsTableBody";
import { VersionsTableFooter } from "./VersionsTableFooter";
import { VersionsTableHead } from "./VersionsTableHead";
import { StorageObjectValue } from "../../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../../services/api/instances/storageApi/types/object_types";

interface Props<T extends StorageObjectValue> {
  versions: StorageObjectVersion<T>[];
  onOk: (id: string) => void;
}

export const VersionsTable = <T extends StorageObjectValue>(
  props: Props<T>,
) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { t } = useTranslation();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  return (
    <AppTable>
      <VersionsTableHead />
      <VersionsTableBody
        versions={props.versions.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage,
        )}
        onOk={props.onOk}
      />
      {props.versions.length > 5 && (
        <VersionsTableFooter
          count={props.versions.length}
          rowsPerPage={rowsPerPage}
          page={page}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} ${t("versioning.table_pagination_separator_preposition")} ${count !== -1 ? count : `${to}`}`
          }
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </AppTable>
  );
};
